export default {
  expertiseId: {
    type: 'string',
    required: true,
  },
  level: {
    type: 'string',
    required: true,
  },
  expertiseType: {
    type: 'string',
    required: true,
  },
  experienceDuration: {
    type: 'string',
    required: true,
  },
  comment: {
    type: 'string',
    required: false,
  },
};
